module.exports = __webpack_public_path__ + "green-check___19PiF.svg";